export default __webpack_public_path__ + "static/media/logo-sicc-us-br.91b68720.png";